import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'
import { useEffect, useState } from 'react'

export const useEmitterVisibility = (emitterTypes: TEmitterType[]) => {
  const [visibleEmitters, setVisibleEmitters] = useState<Partial<Record<TEmitterType, boolean>>>({})

  useEffect(() => {
    setVisibleEmitters(
      emitterTypes.reduce<Partial<Record<TEmitterType, boolean>>>((acc, emitterType) => {
        acc[emitterType] = true

        return acc
      }, {}),
    )
  }, [emitterTypes])

  const toggleEmitterVisibility = (emitterType: TEmitterType) => {
    setVisibleEmitters((prev) => ({
      ...prev,
      [emitterType]: !prev[emitterType],
    }))
  }

  return {
    visibleEmitters,
    toggleEmitterVisibility,
  }
}
